import * as React from "react";
import classnames from "classnames";
import { Heading } from "@grandvisionhq/elements";
/* empty css                  */
const ProductOffer = ({
  title,
  description,
  imageUrl,
  fallbackImageUrl,
  linkTarget,
  url,
  className,
  ...rest
}) => {
  const sharedProps = {
    className: classnames("product-offer__image", {
      "product-offer__image--fallback": !imageUrl
    }),
    "data-t": "ImageContainer"
  };
  return /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("product-offer", className) }, url ? /* @__PURE__ */ React.createElement(
    "a",
    {
      href: url,
      "data-t": "ImageAnchor",
      target: linkTarget,
      rel: linkTarget === "_blank" ? "noreferrer noopener" : void 0
    },
    /* @__PURE__ */ React.createElement("span", { ...sharedProps }, /* @__PURE__ */ React.createElement("img", { src: imageUrl ?? fallbackImageUrl, "data-t": "Image", alt: title }))
  ) : /* @__PURE__ */ React.createElement("div", { ...sharedProps }, /* @__PURE__ */ React.createElement("img", { src: imageUrl ?? fallbackImageUrl, "data-t": "Image", alt: title })), /* @__PURE__ */ React.createElement(Heading, { component: "h4", variant: "subheading1", className: "product-offer__title" }, url ? /* @__PURE__ */ React.createElement(
    "a",
    {
      href: url,
      "data-t": "TitleAnchor",
      target: linkTarget,
      rel: linkTarget === "_blank" ? "noreferrer noopener" : void 0
    },
    title
  ) : title), description && /* @__PURE__ */ React.createElement("p", null, description));
};
export {
  ProductOffer as default
};
//# sourceMappingURL=ProductOffer.js.map
